import axios from "../util/axios";

export const fetchApi = async ({ url, method = "GET", body }) => {
  try {
    const { data } = await axios({
      url,
      method,
      ...((method === "GET" || method === "DELETE") && { params: body }),
      ...((method === "POST" || method === "PUT" || method === "PATCH") && { data: body }),
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const fetchWithError = ({ queryKey }) => {
  const [, queryParams] = queryKey ?? {};
  const { url, method = "GET", body, timeInterval } = queryParams || {};
  
  // If timeInterval is provided, merge it with the body for GET requests
  const requestBody = timeInterval ? { ...body, ...timeInterval } : body;
  
  // Log when transactions API is called
  if (url && url.includes('/transactions')) {
    // API call logging
  }
  
  return fetchApi({ url, method, body: requestBody });
};

export const fetchInfinite = async ({ queryKey, pageParam = 1 }) => {
  const [, queryParams] = queryKey ?? {};
  const { url, method = "GET", body, search = "" } = queryParams || {};
  // `search` (e.g. "?connector=1&action=MeterValues") is appended AFTER the page
  // segment, since the page is a path param (".../logs/:page"). Optional and
  // backward-compatible: callers that omit it get the original ".../:page" URL.
  const { data } = await fetchApi({ url: `${url}/${pageParam}${search}`, method, body });
  return data;
};
